import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import $ from 'jquery';
import DropdownActionsWrapper from '@/components/probaworkflows_base_components/DropdownActionsWrapper/DropdownActionsWrapper.vue'

export default {
  name: 'GlobalTable',
  components:{
    DropdownActionsWrapper
  },
  props: {
    headers: Array,
    data: Array,
    fields: Array,
    table_id: {
      type: String,
      default: 'global_table'
    },
    useActionDropdown: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.initialize_data_table();
  },
  methods: {
    initialize_data_table() {
      this.$nextTick(() => {
        const table_id = `#${this.table_id}`;
        if ($.fn.DataTable.isDataTable(table_id)) {
          $(table_id).DataTable().destroy();
        }

        if (this.data && this.data.length > 0) {
          $(table_id).DataTable({
            autoWidth: false,
            responsive: true,
            ordering: false,
            language: {
              info: "",
              lengthMenu: "_MENU_&nbsp;&nbsp; entries per page",
              emptyTable: ""
            }
          });
        }
      });
    }
  },
  watch: {
    data(new_data) {
      if (new_data && new_data.length > 0) {
        this.initialize_data_table();
      }
    }
  }
};
